module.exports = __webpack_public_path__ + "img/kleisma3.3c136c16.jpg";